import userImage from "Dashboard/images/user.jpg";
import SettingsSlider from "./SettingsSlider";
import UsersList from "./UsersList";
import { IToolTipContentProps } from "components/Tooltip";

const SettingsTooltip = (props: IToolTipContentProps) => {
  return (
    <>
      <div className="settings-tooltip">
        <div className="settings-tooltip-section">
          <SettingsSlider {...props} />
        </div>
        <div className="settings-tooltip-section">
          <span className="settings-tooltip-header">Serijski broj</span>
          <input
            type="text"
            className="settings-input w100 center serial-number"
            value="8620287EA7B2C18D914ED2CA81AFDA343GKO396"
            readOnly
          />
        </div>
        <div className="settings-tooltip-section">
          <span className="settings-tooltip-header mt-10">
            Programerski sati
          </span>
          <div className="user-container">
            <div className="user-item item1">
              <img src={userImage} width="100%" alt="img" />
            </div>
            <div className="user-item item2">
              <input
                type="text"
                className="settings-input full-name w100 center"
                value="Vladimir Blagojević"
                readOnly
              />
            </div>
            <div className="user-item item3">
              <input
                type="text"
                className="settings-input w100 center"
                value="8"
                readOnly
              />
            </div>
            <div className="user-item item4">
              <input
                type="text"
                style={{ float: "right" }}
                className="settings-input w60 center"
                value="FEBRUAR"
                readOnly
              />
            </div>
            <div className="user-item item5">
              <input
                type="text"
                className="settings-input w100 center"
                value="0:26"
                readOnly
              />
            </div>
          </div>
        </div>
        <UsersList {...props} />
      </div>
    </>
  );
};

export default SettingsTooltip;
